import { AltLabel } from '../../TreeViewTypes';
import { DataNode, LabelContext } from '../../data_nodes/types';
import { LabelGenerator, DefaultLabelGenerator } from '../types';

/**
 * Generate default label for Plan nodes
 */
export const generatePlanDefaultLabel: DefaultLabelGenerator = (
  dataNode: DataNode<any>,
  context: LabelContext,
): string => {
  const planData = dataNode.data;

  // Handle plan object with text property
  if (planData && typeof planData === 'object' && 'text' in planData) {
    return planData.text as string;
  }

  // Handle string data directly
  if (typeof planData === 'string') {
    return planData;
  }

  return 'Plan';
};

/**
 * Generate alt labels for Plan nodes
 *
 * Provides options for displaying with or without URL information
 */
export const generatePlanAltLabels: LabelGenerator = (
  dataNode: DataNode<any>,
  context: LabelContext,
): AltLabel[] => {
  const planData = dataNode.data;
  const defaultLabel = generatePlanDefaultLabel(dataNode, context);

  const labels: AltLabel[] = [
    {
      key: 'default',
      selectOption: 'Default: Plan text',
      value: defaultLabel,
    },
  ];

  // Add URL-aware option if plan has a URL
  if (planData && typeof planData === 'object' && 'url' in planData && planData.url) {
    labels.push({
      key: 'with-url',
      selectOption: 'Plan with URL indicator',
      value: `${defaultLabel} (has link)`,
    });
  }

  return labels;
};
